<div>
  <form-generator
    [gridStyle]="1"
    [form]="form"
    [formSchema]="formSchema()"
    [submitFunc]="submit"
    submitSuccessText="Calender Event saved successfully" />
  <div>
    <form-error [form]="form" />
  </div>
</div>
